import { useCallback } from "react";
import { useDispatch } from 'react-redux'
import { changeDsrModalState, changeDsrPopupState } from "../../digital-sales-room/actions/dsr-actions";
import { resetDeepModalTransferPayload, setDeepModalTransferPayload } from "../actions/global-actions";

function useLaunchdeckModal() {

  const dispatch = useDispatch();

  const openLaunchdeckModal = useCallback((modalName, payload) => {
    payload && dispatch(setDeepModalTransferPayload(payload))
    dispatch(changeDsrPopupState(modalName))
    dispatch(changeDsrModalState(true))
  }, []);

  const closeLaunchdeckModal = useCallback(() => {
    dispatch(resetDeepModalTransferPayload())
    dispatch(changeDsrPopupState(""))
    dispatch(changeDsrModalState(false))
  }, []);

  return { openLaunchdeckModal, closeLaunchdeckModal };
}


export default useLaunchdeckModal